import styled from "styled-components";
import { useAuthStore } from '../store/store';

const Contact = () => {
   const { auth } = useAuthStore();
  // const { auth } = useAuthStore();
    // const navigate = useNavigate();
    const isLoggedIn = auth?.isLoggedIn;
  return(
    <Wrapper>
      <h2 className="common-heading">Contact Us</h2>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3777315.160764542!2d68.6841512118513!3d22.399486210484362!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959051f5f0ef795%3A0x861bd887ed54522e!2sGujarat!5e0!3m2!1sen!2sin!4v1739978707699!5m2!1sen!2sin" width="70%" height="250" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
   
      <div className="container">
        <div className="container-container">
          <form  method="POST" className="contact-form">
            <input placeholder="Enter Username"
            type="text"
            name="username" 
            required autoComplete="off" 
            value={isLoggedIn ?auth.username:''}
            />
            <input placeholder="Enter Email"
            type="email"
            name="email" 
            required autoComplete="off" 
            value={isLoggedIn ?auth.email:''}
            />
            <textarea placeholder="Enter Message" 
            required autoComplete="off" 
            name="message">
            </textarea>
            <input type="submit" value="send"/>
          </form>

        </div>

      </div>
   
    </Wrapper>
  )
  };


  const Wrapper = styled.section`
  padding: 9rem 0 5rem 0;
  text-align: center;

  .container {
    margin-top: 6rem;
    }

  .container-container {
    max-width: 50rem;
    margin: auto; 
    }

  .contact-form{
    display: flex;
    flex-direction: column;
    gap: 3rem;
    }

    textarea {
     width: 50rem;
     height: 15rem;
    }

     input[type="submit"]{
    max-width: 16rem;
    margin-top: 2rem;
    background-color: ${({ theme }) => theme.colors.btn};
    color: ${({ theme }) => theme.colors.white};
    padding: 1.4rem 2.2rem;
    border-style: solid;
    border-width: 0.1rem;
    font-size: 1.8rem;
    cursor: pointer;
    }
    
     
  
@media (max-width: ${({ theme }) => theme.media.mobile}){
    padding: 5rem 0 3rem 0;

  .contact-form {
    padding:5%;
    }
  
    textarea {
     width: 100%;
     height: 15rem;     
    }
  }

 `;

  


export default Contact;
